import React, { useEffect } from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props {
  value: string
  onChange: (newTitle: string) => void
  maxLength: number
  onBlur?: () => void
  onFocus?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  loading?: boolean
  hasError?: boolean;
  innerRef?: ReturnType<typeof useSemanticUiInputRef>;
}

const OptionalTextInput = (props: Props) => {
  const semanticRef = props.innerRef ?? useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  const onChange = (_, { value }) => {
    props.onChange(value);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      props.onEsc?.();
    } else if (e.key === "Enter") {
      props.onEnter?.();
    }
  }

  return <Input
    placeholder={props.placeholder}
    ref={semanticRef.refSetter}
    value={props.value}
    onChange={onChange}
    maxLength={props.maxLength}
    onBlur={() => { props.onBlur?.(); }}
    onFocus={() => { props.onFocus?.(); }}
    onKeyDown={onKeyDown}
    fluid
    disabled={props.disabled}
    loading={props.loading}
    error={props.hasError}
  />
};

export default OptionalTextInput;